import {CommandClause, CPCLCommand} from "@psdk/frame-father";
import {BasicCPCLArg} from "./basic";
import {CCodeRotation, CCodeType} from "../types";

export class CBar extends BasicCPCLArg<CBar> {
  private x: number;
  private y: number;
  private content: string;
  private lineWidth: number;
  private height: number;
  private codeRotation: CCodeRotation;
  private codeType: CCodeType;

  constructor(options?: {
    /**
     * 一维码起始横坐标
     */
    x?: number
    /**
     * 一维码起始纵坐标
     */
    y?: number
    /**
     * 条码内容
     */
    content?: string
    /**
     * 条码线宽度
     */
    lineWidth?: number
    /**
     * 条码高度
     */
    height?: number
    /**
     * 条码类型
     */
    codeType?: CCodeType
    /**
     * 旋转
     */
    codeRotation?: CCodeRotation
  }) {
    super();
    this.x = options?.x ?? 0;
    this.y = options?.y ?? 0;
    this.content = options?.content ?? '';
    this.lineWidth = options?.lineWidth ?? 0;
    this.height = options?.height ?? 0;
    this.codeType = options?.codeType ?? CCodeType.CODE128;
    this.codeRotation = options.codeRotation ?? CCodeRotation.ROTATION_0;
  }

  clause(): CommandClause {
    let code;
    switch (this.codeType) {
      case CCodeType.CODE39:
        code = new CodeTypeEntity('39', '2');
        break;
      case CCodeType.CODE128:
        code = new CodeTypeEntity('128', '2');
        break;
      case CCodeType.CODE93:
        code = new CodeTypeEntity('93', '1');
        break;
      case CCodeType.CODABAR:
        code = new CodeTypeEntity('CODABAR', '2');
        break;
      case CCodeType.EAN8:
        code = new CodeTypeEntity('EAN8', '2');
        break;
      case CCodeType.EAN13:
        code = new CodeTypeEntity('EAN13', '2');
        break;
      case CCodeType.UPCA:
        code = new CodeTypeEntity('UPCA', '2');
        break;
      case CCodeType.UPCE:
        code = new CodeTypeEntity('UPCE', '2');
        break;
      case CCodeType.I2OF5:
        code = new CodeTypeEntity('I2OF5', '2');
        break;
    }


    return CPCLCommand.with(this.header())
      .appendText(this.codeRotation.toString())
      .appendText(code.type)
      .appendNumber(this.lineWidth)
      .appendNumber(2)
      .appendNumber(this.height)
      .appendNumber(this.x)
      .appendNumber(this.y)
      .appendText(this.content)
      .clause();
  }

  header(): string {
    return '';
  }
}

class CodeTypeEntity {
  type: string;
  width: string;

  constructor(type, width) {
    this.type = type;
    this.width = width;
  }
}

